import { platformOutcome } from '../../../shared/platform-outcome';
import { isValidPlatformPostId } from '../../../shared/platform-post-id';

import { isUnsupportedPublishPlatform } from './unsupported-publish';

export interface UnsentPlatform {
  platform: string;
  reason: 'never_sent' | 'failed';
  error: string | null;
}

export interface PartialDelivery {
  sent: string[];
  unsent: UnsentPlatform[];
}

export function partialDelivery(post: {
  status?: string | null;
  platforms?: unknown;
  platform_response?: unknown;
  platform_schedules?: unknown;
}): PartialDelivery | null {
  if (post.status !== 'partially_published' && post.status !== 'partially_scheduled') return null;
  const intended = Array.isArray(post.platforms)
    ? (post.platforms as unknown[]).filter(
        (value): value is string =>
          typeof value === 'string' && !isUnsupportedPublishPlatform(value),
      )
    : [];
  const sent: string[] = [];
  const unsent: UnsentPlatform[] = [];
  for (const platform of intended) {
    const detail = platformOutcome(
      platform,
      post.platform_response,
      post.platform_schedules,
      isValidPlatformPostId,
    );
    if (detail.outcome === 'published') sent.push(platform);
    else if (detail.outcome === 'not_attempted') {
      unsent.push({ platform, reason: 'never_sent', error: null });
    } else if (detail.outcome === 'failed') {
      unsent.push({ platform, reason: 'failed', error: detail.error });
    }
  }
  if (sent.length === 0 || unsent.length === 0) return null;
  return { sent, unsent };
}

export function listPlatformNames(labels: readonly string[]): string {
  if (labels.length <= 1) return labels[0] ?? '';
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
}
